import React from 'react';
import { useTranslation } from 'react-i18next';

import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import MoreInfoSection from '@/sections/MoreInfo';
import { LINKS } from '@/constants/links';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconUser from '@/assets/icons/heroIcons/User-group.svg';
import IconCoins from '@/assets/icons/heroIcons/Coins.svg';

export function MoreInfo(): React.JSX.Element {
	const { t } = useTranslation(['core']);
	const isCsLanguage = useIsSelectedLanguage('cs');
	return (
		<MoreInfoSection
			buttons={
				isCsLanguage
					? [
							{
								analyticsParam: 'termsAndConditionsMoreInfoDeferredPayment',
								icon: <IconDeferredPayment className="fillButtonIcon" />,
								testId: 'termsAndConditionsMoreInfoDeferredPayment',
								title: t('core:products.deferredPayment'),
								to: LINKS().deferredPayment,
							},
							{
								analyticsParam: 'termsAndConditionsMoreInfoRevolvingApplication',
								icon: <IconMaxi className="fillButtonIcon" />,
								testId: 'termsAndConditionsMoreInfoRevolvingApplication',
								title: t('core:products.revolving'),
								to: LINKS().revolving,
							},
							{
								analyticsParam: 'termsAndConditionsMoreInfoPayInThree',
								icon: <IconThird className="fillButtonIcon" />,
								testId: 'termsAndConditionsMoreInfoPayInThree',
								title: t('core:link.payInThree'),
								to: LINKS().payInThree,
							},
							{
								analyticsParam: 'termsAndConditionsMoreInfoCard',
								icon: <IconCard className="fillButtonIcon" />,
								testId: 'termsAndConditionsMoreInfoCard',
								title: t('core:products.card'),
								to: LINKS().card,
							},
						]
					: [
							{
								analyticsParam: 'termsAndConditionsMoreInfoPayInThree',
								icon: <IconThird className="fillButtonIcon" />,
								testId: 'termsAndConditionsMoreInfoPayInThree',
								title: t('core:products.payInThree'),
								to: LINKS().payInThree,
							},
							{
								analyticsParam: 'payInThreeMorePricing',
								icon: <IconCoins className="fillButtonIcon" />,
								testId: 'termsAndConditionsMorePricing',
								title: t('core:products.pricing'),
								to: LINKS().pricing,
							},
							{
								analyticsParam: 'termsAndConditionsMobileApp',
								icon: <IconMobile className="fillButtonIcon" />,
								testId: 'termsAndConditionsMoreInfoMobileApp',
								title: t('core:products.mobileApp'),
								to: LINKS().mobileApp,
							},
							{
								analyticsParam: 'termsAndConditionsMoreInfoAboutCompany',
								icon: <IconUser className="fillButtonIcon" />,
								testId: 'termsAndConditionsMoreInfoAboutCompany',
								title: t('core:link.aboutUs'),
								to: LINKS().aboutCompany,
							},
						]
			}
		/>
	);
}
